import { render, staticRenderFns } from "./CreateEmailCouponComponent.vue?vue&type=template&id=2c1edf7d"
import script from "./CreateEmailCouponComponent.vue?vue&type=script&lang=js"
export * from "./CreateEmailCouponComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports